export default {
  mysql : {
      title : 'RDS for MySQL',
      common : {
        series : 'Series',
        storage : 'Storage',
        zone : 'Zone',
        typePrimary : 'Primary',
        typeReadonly : 'Readonly',
      },
      list : {
        searchHolder : 'Search for Name',
        columnName : 'Name / ID',
        columnVersion : 'MySQL Version',
        columnRole : 'Instance Role',
        columnPeriod : 'Validity Period',
        columnCharge : 'Charges ($)',
        columnStatus : 'Status',
        actionManager : 'Manage',
        actionRenew : 'Renew',
        actionUpgrade : 'Upgrade',
        actionRestore : 'Restore',
        seriesHigh : 'High Availability',
        seriesBasic : 'Basic',
        noDataTips : 'No data found, you can',
        noDataAction : 'create an instance',
        purchaseBtnTips : 'Purchase MySQL',
      },
      manageMenu : {
        basic : 'Basic <br />Information',
        account : 'Accounts',
        db : 'Databases',
        backup : 'Backup & <br />Restoration',
        monitor : 'Monitoring',
        log : 'Logs',
        param : 'Parameters',
      },
      detail : {
        actionBackup : 'Back Up',
        actionRestart : 'Restart',
        createdLabel : 'Created At',
        basicInfo : {
          title : 'Basic Information',
          name : 'Name',
          type : 'Type',
          storageType : 'Storage',
        },
        connection : {
          title : 'Connection Information',
          innerAddress : 'Internal IP Address',
          innerPort : 'Internal IP Port',
          outerAddress : 'Public IP Address',
          outerPort : 'Public IP Port',
          actionApply : 'Apply for Public Endpoint',
          actionEdit : 'Mass Actions',
          actionReleasePublic : 'Release extranet address',
          actionReleaseConnections : 'Maximum Connections to Extranet',
          releaseConnectionsTips : 'Release extranet connections',
          publicBandWidth : 'Maximum Bandwidth of Extranet',
          actionSpeed : 'Upgrade Bandwidth',
          actionWhitelist : 'Edit Extranet Whitelist',
          whitelistTitle : 'Edit Extranet Whitelist',
        },
        status : {
          title : 'Running State',
          status : 'Status',
          methodLabel : 'Billing Method',
          method : 'Monthly',
          created : 'Creation Time',
          overdueTips : 'Expired ${yisuReplace} Days Ago',
          willOverdueTips : 'Expires in ${yisuReplace} days',
        },
        configuration : {
          title : 'Configuration Information',
          version : 'Database Version',
          cpu : 'CPU',
          memory : 'Database Memory',
          iops : 'Maximum IOPS',
          connections : 'Maximum Connections',
          maintainPeriod : 'Maintainable Period',
          actionEdit : 'Edit',
        },
        usage : {
          title : 'Usage Statistics',
          used : 'Used',
          total : 'Total',
          backup : 'BackupUsage',
          data : 'Data Backup Usage',
          log : 'Log Backup Usage',
        },
      },
      accounts : {
        actionCreate : 'Create Account',
        actionDelete : 'Delete',
        actionRemark : 'Edit Desc',
        actionEdit : 'Reset Permissions',
        actionResetHigh : 'Reset High Account Permission',
        actionPassword : 'Reset Privilege',
        actionPassword : 'Reset Password',
        columnAccount : 'Account',
        columnType : 'Account Type',
        columnOuter : 'Outer Connection Account',
        columnDbs : 'Database',
        columnDesc : 'Description',
        columnStatus : 'Status',
        statusActive : 'active',
        statusExpired : 'Expired',
      },
      database : {
        actionCreate : 'Create Database',
        actionRemark : 'Edit desc',
        actionDelete : 'Delete',
        columnDbName : 'Database Name',
        columnAccounts : 'User Account',
        columnCharacter : 'Character Set',
        columnStatus : 'Database Status',
        columnDesc : 'Description',
        statusExpired : 'Expired',
        statusActive : 'Active',
      },
      backup : {
        data : {
          title : 'Data Backup',
          columnPeriod : 'Start/End Time',
          columnName : 'FileName',
          columnSize : 'Size',
          columnTime : 'Snapshot Time',
          columnMethod : 'Method',
          columnType : 'Type',
          columnStatus : 'Status',
          statusExpired : 'Expired',
          statusSuccess : 'Success',
          actionConvert : 'Convert to SQL',
        },
        log : {
          title : 'Log Backup',
          columnStart : 'Record Start Time',
          columnEnd : 'Record End Time',
          columnSize : 'Size',
        },
        setting : {
          title : 'Backup Settings',
          retentionLabel : 'Data Backup Retention (Days)',
          cycleLabel : 'Backup Cycle',
          nextLabel : 'Approximate Time of Next Backup',
          action : 'Configure',
        },
        actionDownload : 'Download',
        actionRecover : 'Database/Table Level Recovery',
        startHolder : 'Start Time',
        endHolder : 'End Time',
        keywordHolder : 'Enter Search Filename',
      },
      monitor : {
        engine : {
          title : 'Engine Monitoring',
          option1Title : 'Transactions Per Second(TPS) / Queries Per Second(QPS)',
          option1Legend : ["Average TPS", "Average QPS"],
          option2Title : 'InnoDB Buffer Pool Read Hit Ratio, Utilization Rate, Dirty Block Rate (%)',
          option2Legend : ["Buffer Pool Read Hit Ratio (%)", "Buffer Pool Usage Rate (%)", "Buffer Pool Ratio of Dirty Blocks(%)"],
          option3Title : 'InnoDB Read/Write Volume (KB)',
          option3Legend : [
            "InnoDB Average Data Volume Read Rate (KB/s)",
            "InnoDB Average Data Volume Read Rate (KB/s)",
          ],
          option4Title : 'InnoDB Buffer Pool Read/Write Frequency (Hz)',
          option4Legend : [
            "InnoDB Buffer Pool Average Read Frequency",
            "InnoDB Buffer Pool Average Write Frequency",
          ],
          option5Title : 'InnoDB Log Read/Write/fsync',
          option5Legend : [
            "Log Write Request Frequency",
            "Average Frequency of Physical Writes to Log File",
            "Average Frequency of fsync() Writes to Log File",
          ],
          option6Title : 'Temporary Tables Automatically Created on Hard Disk when MySQL Statements Are Executed',
          option6Legend : [],
          option7Title : 'MySQL_COMDML',
          option7Legend : [
            "Average Frequency of Delete statement executions",
            "Average Frequency of Insert statement executions",
            "Average Frequency of Insert_Select statement executions",
            "Average Frequency of Replace statement executions",
            "Average Frequency of Replace_Select statement executions",
            "Average Frequency of Select statement executions",
            "Average Frequency of Update statement executions",
          ],
          option8Title : 'MySQL_RowDML',
          option8Legend : [
            "Average Frequency of Line Reads from InnoDB Table",
            "Average Frequency of Line Updates from InnoDB Table",
            "Average Frequency of Line Deletes from InnoDB Table",
            "Average Frequency of Line Inserts from InnoDB Table",
            "Average Frequency of Physical Writes to Log File",
          ],
          option9Title : 'MyISAM Read/Write Frequency',
          option9Legend : [
            "Average Frequency of MyISAM Reads from Buffer Pool",
            "Average Frequency of MyISAM Writes from Buffer Pool",
            "Average Frequency of MyISAM Reads from Hard Disk",
            "Average Frequency of MyISAM Writes from Hard Disk",
          ],
          option10Title : 'MyISAM Key Buffer Read/Write/Usage Ratio (%)',
          option10Legend : [
            "MyISAM Average Key Buffer Usage Ratio (%/s)",
            "MyISAM Average Key Buffer Read Hit Ratio (%/s)",
            "MyISAM Average Key Buffer Write Hit Ratio (%/s)",
          ],
        },
        resource : {
          title : 'Resource Monitoring',
          option1Title : 'CPU Utilization and Memory Usage (%)',
          option1Legend : ["CPU Utilization", "Memory Usage"],
          option2Title : 'Disk Space (MB)',
          option2Legend : [
            "Instance Size",
            "Data Usage",
            "Log Size",
            "Temporary File Size",
            "Other System File Size",
          ],
          option3Title : 'IOPS (Input/Output Operation per Second)',
          option3Legend : ["IOPS for Current Instance"],
          option4Title : 'Total Connections',
          option4Legend : ["Total Connections", "Active Connections"],
          option5Title : 'Network Traffic (KB)',
          option5Legend : [
            "Average input flow per second",
            "Average output flow per second",
          ],
        },
        error : 'Failed to Get Monitoring Data',
        actionSetting : 'Set Monitoring Frequency',
        startHolder : 'startTime',
        endHolder : 'endTime',
      },
      log : {
        detail : {
          title : 'Slow Log Details',
          columnTime : 'Slow log collection time',
          columnStatment : 'SQL Statement',
          columnIp : 'Client IP Address',
          columnDb : 'Database Name',
          columnExecute : 'Execution Duration (s)',
          columnLock : 'Lock Duration (s)',
          columnParsed : 'Rows Parsed',
          columnReturned : 'Rows Returned',
        },
        summary : { 
          title : 'Slow Log Summary',
          columnTime : 'Time',
          columnDb : 'Database Name',
          columnStatment : 'SQL Statement',
          columnExecutions : 'Execution Details',
          columnPendding : 'Pending Unlock',
          columnExamined : 'Rows Examined',
          columnReturned : 'Rows Returned',
          ExecutionTotal : 'Total Executions',
          ExecutionsTime : 'Total Execution Time',
          ExecutionsTimeMax : 'Maximum Execution Time',
          totalLock : 'Total Lock Time',
          maxLock : 'Maximum Lock Time',
          totalParse : 'Total Number of Parsed Rows',
          maxParse : 'Maximum Number of Parsed Rows',
          totalReturn : 'Total Number of Returned Rows',
          maxReturn : 'Maximum Number of Returned Rows',
        },
        actionSetting : 'Slow Query Setting',
        searchHolder : 'Enter Search SQL Statement',
      },
      param : {
        columnName : 'Parameter Name',
        columnValue : 'Parameter Value',
        columnDesc : 'Description',
        columnStart : 'Force Restart',
        actionEdit : 'Edit',
      },
      modals : {
        common : {
          columnName : 'Name',
          columnConfiguration : 'Configuration',
          columnType : 'Database Type',
          columnZone : 'Zone',
          columnExpired : 'Expired at',
        },
        rename : {
          title : 'Rename',
          warn : 'Sure to rename <span>${yisuReplace}</span> ?',
          holder : 'Please enter a new Name here',
          new : 'New Name:',
          tips : '2-64 Characters',
        },
        restart : {
          title : 'Restart Instance',
          tips : 'Sure to reload instance <span> ${yisuReplace} </span> ?',
          action : 'Restart',
        },
        renew : {
          title : 'Renew',
          durationDays : 'Length (Days): ',
          duration : 'Duration:'
        },
        upgrade : {
          title : 'Upgrade',
          tips : "RDS configuration changes may involve the migration of underlying\ndata, please be patient.After the migration is completed, the switch\nwill be performed, and there will be a flash for about 30 seconds\nduring the switch. Please make sure that the application has a\nreconnection mechanism.",
          delay : 'Within maintainable time (${yisuReplace}) Edit',
          now : 'Immediately after data migration',
          switch : 'Switch Time:',
          product : 'Product :',
        },
        releaseAddress : {
          title : 'Release Extranet Address',
          warn : 'Sure to release the external network address?',
          tips : "If the external network address is released, the MySQL instance cannot be connected through the current connection address.",
          actionRelease : 'Release',
        },
        whitelist : {
          title : 'Edit Extranet Whitelist',
          whitelistLabel : 'Whitelist',
          ipEmpty : 'ips not allow empty',
          ipLess : 'effective ips are less than 1',
          ipLimit : 'ips quantity should not be more than 50',
          ipInvalid : 'ips format error',
          tips : 'Separate multiple IPs with commas.\n0.0.0.0/0 means that all addresses are allowed to access the\nextranal network address 127.0.0.1 means that all addresses are\nforbidden to access\n',
        },
        editAddress : {
          title : 'Edit Extranet Address',
          nameLabel : 'Name',
          warn1 : 'Start with a lowercase letter.',
          warn2 : 'Limit length to 22~50 characters.',
          warn3 : 'Support letters, numbers and hyphens.',
          warnNoChange : 'The connection string was not modified',
          warnLimit : 'Limit length to 22~50 characters',
        },
        setMaintain : {
          title : 'Edit Maintainable Period',
          label : 'Set the maintenance period',
          symbol : 'To',
          holderStart : 'Start Time',
          holderEnd : 'End Time',
        },
        connections : {
          title : 'Release Extranet Session Connection',
          columnId : 'ID',
          columnVisitor : 'Visitor IP',
          columnAccount : 'Account',
          columnTime : 'Connection Time',
          warnNoSelect : 'There are no connections selected to release',
          warnNoConnections : 'No connections currently',
          action : 'Release',
          actionAll : 'Release ALL',
        },
        speed : {
          title : 'Increase Bandwidth Temporarily',
          warn : 'Sure to increase bandwidth from 5M to 10M for 24 hours?',
          tips : 'After 24 hours, the bandwidth will be back to 5M.',
          action : 'Speed Up',
        },
        applyAddress : {
          title : 'Apply for Public Endpoint',
          tips1 : "Since operating the cloud database MySQL through the external\nnetwork address will greatly reduce the transmission efficiency,\nplease do not use the external network address in the application of\nthe production environment.",
          tips2 : "After the external network address is enabled, the database account\nlist will show the external network connection account of each\naccount, and the external network connection account is required to\naccess the database on the external network.",
          action : 'confirm',
        },
        addAccount : {
          title : 'Create Account',
          nameLabel : 'Database Account',
          nameHolder : 'Please enter a database account here',
          nameRule : 'The account name must be 1 to 16 characters in length and can contain lowercase letters, digits,and underscores(_). It must start with a letter and end with a letter or digit.',
          privilegeLabel : 'Privilege Type',
          typeHigh : 'High',
          typeOrdinary : 'Ordinary',
          ordinaryTips : '(Data could only be imported to authorized database.)',
          actionSelectDb : 'Unauthorized Database',
          actionAuthorize : 'Authorize',
          columnAuthorized : 'Authorized Database',
          columnPrivilege : 'Grant Privilege',
          radioWrite : 'Read-write',
          radioRead : 'Read-only',
          radioDDL : 'DDL',
          radioDML : 'DML',
          all : 'ALL Set',
          passwordLabel : 'New Password',
          passwordHolder : 'Please enter a new password here',
          passwordRule : "8~32 charaters. At least consists of 3 kinds of upper/lower-case\nletters, numbers, and special charaters (!@#^&*()_+-=)",
          confirmPassword : 'Confirm Password',
          descLabel : 'Description',
        },
        accountPassword : {
          title : 'Reset Password',
          tips : 'Reset the password for ${yisuReplace}',
        },
        deleteAccount : {
          title : 'Delete Account',
          tips : 'Sure to delete <span>${yisuReplace}</span>',
          warn : 'After deleting, it is not recoverable, please delete with caution',
        },
        accountRemark : {
          title : 'Remark',
          remarkHolder : 'Please enter remarks here',
          tips : 'Modify the remarks for <span>${yisuReplace}</span>',
          warn : 'Please enter comments',
        },
        accountPrivilege : {
          title : 'Reset Permissions',
          tips : 'change privilege for ${yisuReplace}',
        },
        resetHigh : {
          title : 'Reset High Permissions Account Privilege',
          tips : 'Do you really want to reset the permissions of the high permission account ?',
          warn : 'After resetting, the permission modification you made to the high permission account will be reset to the system default assigned permission',
        },
        createDatabase : {
          title : 'Create Database',
          nameLabel : 'Database Name',
          nameHolder : 'Please enter a database name here',
          tips : 'The database name must be 2 to 64 characters in length and can contain lowercase letters, digits, uderscgres (), and hyphens (). It must start with a letter land end with a letter or digit.',
          charsetLabel : 'Character Set',
          otherCharset : 'Other',
          authAccountLabel : 'Authorize Accounts',
          unauthAccountHolder : 'Unauthorized Account (default)',
          buttonCreateAccount : 'Create an Account',
          privilegeLabel : 'Account Privilege',
          descLabel : 'Description',
          descHolder : 'The description must be 0 to 256 characters in length.',
          nameWarn : 'Database name format error',
          accountWarn : 'Please Select Account Privilege',
          charactorWarn : 'Please Select Character Set',
          descWarn : 'The description must be 0 to 256 characters in length.',
        },
        deleteDatabase : {
          title : 'Delete Database',
        },
        databaseRemark : {
          title : 'Edit Description',
          tips : 'Modify the description for <span>${yisuReplace}</span>',
          holder : 'Please enter description here',
          enterWarn : 'Please enter description here',
          noModifiedWarn : 'No modification',
          limitWarn : 'Description Limit 256',
        },
        downloadBackup : {
          title : 'Download Instance Backup File',
          dataTips : 'When ECS and RDS are in the same region, the intranet download address is used on ECS, and the download speed and security are higher.',
          logTips : 'When ECS and RDS are in the same region, using Intranet download address on ECS will increase the download speed and security.',
          warn : "If you have not installed the Flash plug-in or the version is too low,\nthe 'Copy Download Address' function will not be available.",
          dataCopy : 'Copy Download Address',
          logCopy : 'Copy Url',
          download : 'Download',
        },
        convertBakcup : {
          title : 'Convert to SQL',
          tips : 'Convert the xb file to a SQL file?',
          convert : 'Convert',
        },
        backupSetting : {
          title : 'Backup Settings',
          retentionLabel : 'Data Retention Days',
          cycleTips : 'Click on the drop-drwn menu to select or deselect',
          cycleLabel : 'Backup Cycle',
          timeLabel : 'Backup Time',
          monday : 'Monday',
          tuesday : 'Tuesday',
          wednesday : 'Wednesday',
          thursday : 'Thursday',
          friday : 'Friday',
          saturday : 'Saturday',
          sunday : 'Sunday',
          tips1 : "Backup usage exceeding the free quota will incur additional costs.\nFor details, please refer to the billing document.",
          tips2 : "To update the backup settings, you need to restart the MySQL\nservice.",
          tips3 : 'It takes about 30s~60s to change the backup settings.',
        },
        backupRecover : {
          title : 'Restore Indivdual Database/Table',
          methodLabel : 'Restoration method',
          methodSets : 'By Backup Set',
          methodTime : 'By Time',
          setsLabel : 'Backup Set',
          timeLabel : 'Select Restore Time',
          unSelectedLabel : 'Database and Tables to Restore',
          columnDb : 'Database Name',
          dbKeywordHolder : 'Search by database',
          columnTb : 'Table Name',
          tbKeywordHolder : 'Search by table',
          selectHolder : 'Select',
          noDataTips : 'No data available',
          selectedLabel : 'Selected Databases and Tables',
          columnNewDb : 'New Database Name',
          columnNewTb : 'New Table Name',
          actionDelete : 'Delete',
          sumLabel : 'Total Storage of Selected',
          tips1 : "An HA switch will be performed during the database table recovery,\nplease confirm the connection after recovery.",
          tips2 : "Please pay attention to the server status and database form update\nresults for the recovery results",
        },
        backup : {
          title : 'Back Up Instance',
          mode : 'Backup Mode',
          modePhysic : 'Physical Backup',
          modeLogic : 'Logical Backup',
          tips : 'The backup task will start in about 1 minute',
          strategy : 'Backup Strategy',
          strategyDb : 'Database Backup',
          strategyInstance : 'Instance Backup',
          dbLabel : 'dbName',
          actoin : 'Back Up',
        },
        monitorSetting : {
          title: 'Set Monitoring Frequency',
          label : 'Monitoring frequency',
          unit : 'Seconds/Time',
          tips1 : 'Current instance configuration:${mysqlSeries} Edition, ${mysqlMemory} GB',
          tips2 : "The basic version and database instances with less than 8G memory\ndo not support the collection frequency of 5 seconds/time.",
        },
        setSlow : {
          title : 'Set Slow Query',
          tips : 'Cancel Done Enabling slow queries may affect performance.',
          timeLabel : 'Slow Query Time (Seconds)',
          switchLabel : 'Slow Query Switch',
        },
        paramSetting : {
          title : 'Edit Setting',
          keyLabel : 'Key',
          valueLabel : 'Value',
        },
      }
    }
}



// WEBPACK FOOTER //
// ./src/lang/en/mysql.js